import { RESERVATION_TAB_KEYS } from "./reservationTabConfig";

export const RESERVATION_LIST_ACTION_KEYS = {
    VIEW: "view",
    START_RESERVATION: "startReservation",
    END_RESERVATION: "endReservation",
};

export const viewReservation = (history, reservation) => {
    if (!reservation?.id) {
        return;
    }

    history.push(`/reservations/${reservation.id}`);
};

export const startReservation = (history, reservation) => {
    if (!reservation?.id) {
        return;
    }

    history.push(`/reservations/${reservation.id}/check-in`);
};

export const endReservation = (history, reservation) => {
    if (!reservation?.id) {
        return;
    }

    history.push(`/reservations/${reservation.id}/check-out`);
};

/** Row menu for a reservation, shared by the desktop table and the mobile cards. */
export const buildReservationActionItems = (reservation, tabKey, t) => {
    const items = [{ label: t("view"), key: RESERVATION_LIST_ACTION_KEYS.VIEW }];

    if (tabKey === RESERVATION_TAB_KEYS.UPCOMING && reservation?.carSelected) {
        items.push({ label: t("startReservation"), key: RESERVATION_LIST_ACTION_KEYS.START_RESERVATION });
    }
    if (tabKey === RESERVATION_TAB_KEYS.ONGOING) {
        items.push({ label: t("_ongoing.endReservation"), key: RESERVATION_LIST_ACTION_KEYS.END_RESERVATION });
    }

    return items;
};

export const getTabSectionTitleKey = (tabKey) => {
    switch (tabKey) {
        case RESERVATION_TAB_KEYS.UPCOMING:
            return "_upcoming.rides";
        case RESERVATION_TAB_KEYS.ONGOING:
            return "_ongoing.ongoingRides";
        case RESERVATION_TAB_KEYS.PAST:
            return "completedRides";
        case RESERVATION_TAB_KEYS.REJECTED:
            return "rejectedRequests";
        case RESERVATION_TAB_KEYS.CANCELLED:
            return "cancelledRides";
        case RESERVATION_TAB_KEYS.ALL:
            return "allReservations";
        default:
            return "allReservations";
    }
};
